var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "catalog-map__placeholder" }),
    _vm._v(" "),
    _c(
      "div",
      { ref: "catalogMap", staticClass: "catalog-map yamap" },
      [
        _c(
          "transition",
          { attrs: { name: "fade", duration: "450", tag: "div" } },
          [
            (_vm.placemarksData.list.length == 0) & (_vm.map != null)
              ? _c("div", { staticClass: "catalog-layout__content_empty" }, [
                  _c("p", [_vm._v("Нет результатов")])
                ])
              : _vm._e()
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }